import { render } from "./AddTypeActeurPage.vue?vue&type=template&id=46e9cbec&ts=true"
import script from "./AddTypeActeurPage.vue?vue&type=script&lang=ts"
export * from "./AddTypeActeurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__